/**
 * SPA 内 navigation 用の相対パス安全化ヘルパ。
 *
 * `location.state.returnTo` などクライアント側で書き換え可能な値を `navigate()` に渡す前に、
 * `/` 起点かつ `//`（protocol-relative URL）で始まらないパスのみ許可し、
 * それ以外は fallback（既定 `/`）に落とす。多重防御としてのガード（PR-3 レビュー指摘）。
 *
 * NOTE: 現状 `location.state` は同一オリジン SPA 内でしか設定できず、外部ドメイン注入経路は
 * 通常存在しないため実害は低いが、`safePolicyUrl` 側と同様のガード思想を揃える目的。
 */
export const sanitizeReturnTo = (
  returnTo: unknown,
  fallback: string = '/',
): string => {
  if (typeof returnTo !== 'string') return fallback;
  if (!returnTo.startsWith('/')) return fallback;
  // `//` は protocol-relative URL、`/\` は一部ブラウザで `//` と同等に解釈される
  // ため、両方を fallback 対象に含める（多重防御 / PR-3 レビュー nit 指摘）。
  if (returnTo.startsWith('//') || returnTo.startsWith('/\\')) return fallback;
  return returnTo;
};
